import { Component, Inject } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet'
import { IHeaderRouteInfo } from '../main-header/main-header.interface'

@UntilDestroy()
@Component({
  selector: 'mg-sidemenu-bottom-sheet',
  templateUrl: './sidemenu-bottom-sheet.component.html',
  styleUrls: ['./sidemenu-bottom-sheet.component.scss'],
  standalone: false
})
export class SidemenuBottomSheetComponent {
  showThemeOptions = false

  constructor(
    public bottomSheetRef: MatBottomSheetRef<SidemenuBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { items: IHeaderRouteInfo[]; type: 'main' | 'profile' }
  ) {}
}
